import script from "./refund-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./refund-modal.vue?vue&type=script&setup=true&lang=js"

import "./refund-modal.vue?vue&type=style&index=0&id=79c9e1d0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c9e1d0"]])

export default __exports__